<template>
  <a-flex
    v-if="column.dataIndex === 'status'"
    gap="small"
    align="center"
    justify="center"
  >
    <span>{{ column.title }}</span>

    <a-popover placement="bottom" trigger="click">
      <template #content>
        <a-flex vertical gap="small">
          <a-button
            type="text"
            v-for="item in MarkingCodesRegistryStatusOptions"
            :key="item.value"
          >
            {{ item.title }}
          </a-button>
        </a-flex>
      </template>

      <a-button type="text" :icon="h(FilterOutlined)"></a-button>
    </a-popover>
  </a-flex>

  <a-flex
    v-else-if="column.dataIndex === 'movement'"
    gap="small"
    align="center"
    justify="center"
  >
    <span>{{ column.title }}</span>

    <a-popover placement="bottom" trigger="click">
      <template #content>
        <a-flex vertical gap="small">
          <a-button
            type="text"
            v-for="item in MarkingCodesRegistryMovementOptions"
            :key="item.value"
          >
            {{ item.title }}
          </a-button>
        </a-flex>
      </template>

      <a-button type="text" :icon="h(FilterOutlined)"></a-button>
    </a-popover>
  </a-flex>

  <a-flex
    align="center"
    justify="center"
    gap="small"
    v-else-if="column.dataIndex === 'code'"
  >
    <a-typography-text>{{ column.title }}</a-typography-text>

    <HonestSignFillIcon class="icon" />
  </a-flex>

  <template v-else>
    {{ column.title }}
  </template>
</template>

<script setup lang="ts">
import {
  MarkingCodesRegistryMovementOptions,
  MarkingCodesRegistryStatusOptions,
  type MarkingCodesRegistryTableItem,
} from "@/stores/product/marking/marking-codes-registry.store";
import { FilterOutlined } from "@ant-design/icons-vue";
import { h } from "vue";
import HonestSignFillIcon from "@/svgIcons/HonestSignFillIcon.vue";

defineProps<{
  column: {
    dataIndex: keyof MarkingCodesRegistryTableItem;
    title: string;
  };
}>();
</script>

<style scoped lang="scss">
.ant-popover {
  .ant-btn {
    width: 100%;
  }
}

.icon {
  width: 16px;
  height: 16px;
}
</style>
